import React from 'react';
import { TextField, TextFieldProps } from './index';
import LanguageSelect from '../language-select';
import { useLocalizedField } from '@components/hooks/use-localised-field';

import { I18NText } from '@api/ChallengeClient';
import { I18n } from '@core/i18n';

interface LocalizedTextFieldProps
    extends Omit<TextFieldProps, 'value' | 'onChange'> {
    value: I18NText;
    onChange(value: I18NText): void;
}

const LocalizedTextField = ({
    value,
    onChange,
    ...props
}: LocalizedTextFieldProps) => {
    const { selectedValue, options, language, setLanguage } = useLocalizedField(
        value,
        I18n.allLanguageOptions,
        I18n.mainLanguageKey
    );

    function handleOnChange(e: string) {
        onChange({ ...value, [language]: e });
    }

    return (
        <TextField
            {...props}
            value={selectedValue}
            onChange={handleOnChange}
            InputProps={{
                endAdornment: (
                    <span>
                        <LanguageSelect
                            options={options}
                            value={language}
                            onChange={setLanguage}
                        />
                    </span>
                )
            }}
        />
    );
};

export default LocalizedTextField;
